import React, { Component } from 'react'
import { connect } from 'react-redux'
import { identity, partial } from 'lodash'

import PaintSummary from 'components/PaintSummary'
import PaintColorSwapModal from 'components/PaintColorSwapModal' 

import { getTopVM } from 'state/viewModels'
import * as actions from 'ducks/modules/customize'
import PaintFillChooser from 'components/PaintFillChooser'
import LineChooser from 'components/LineChooser'
import NavWarning from 'containers/NavWarning'
import { TrackedButtonLink } from 'components/Buttons'

export class TopForm extends Component {
  constructor() {
    super();
    this.state = {
      currentPaintFill: null,
    };
  }
  setCurrentPaintFill(paint) {
    let colorObj = {};
    colorObj.color = paint;
    if(!paint)
      colorObj = paint;
    this.setState({currentPaintFill: colorObj});
  }
  
  componentWillMount(){
    this.props.selectView('PP') 
  }
  render = () => (<div>
    <div className="customize-form-header">Top</div>
	  {this.props.paintFillLocations.length === 0 && (this.props.sightDots.options.length === 1 && this.props.sightDots.options[0].numberOfLines === 0 && this.props.topLines.options.length === 0) && this.props.flangeLines.options.length === 0 &&
      <div className="customize-form-section">
        <div className="instructional-text">
          There are no customization options on this view.
        </div>
      </div>
    }
    <div className="customize-form-section">
      {this.props.paintFillLocations.length > 0 && 
        <div className="customize-form-section-header">Select Colors</div>
      }
      {/*If paintFill id is not 6 (new paintfill) then link them back to finish to select a customize color option*/}
      {this.props.paintFillLocations.length > 0 && this.props.paintFill.id !== 6 &&
        <div className="customize-form-section-content">
          <div className="enable-paintfill-question">Did you want to customize your colors?</div>
          <div className="enable-paintfill-link" type="button" onClick={() => this.props.onEnablePaintFill('paintFill', 6)}>
            Enable Paintfill
            {!(this.props.buyAPutter && this.props.buyAPutter.selected) && 
              <span> ${this.props.paintFillPrice}</span>
            }
          </div>
          <div className="clearfix"></div>
        </div>
      }
      {this.props.paintFillLocations.length > 0 && this.props.paintFill.id === 6 &&
        <div className="customize-form-section-content">
          <div className="paintfill-tools"> 
            <PaintSummary 
              paints={this.props.paintSummary} 
              maxPaintfillColors={this.props.maxPaintfillColors} 
              onClick={ (paint) => this.setCurrentPaintFill(paint) }/>
            <div className="reset-colors-link" type="button" onClick={() => this.props.resetPaintFills()}>
              Reset to Original
            </div>
            <div className="reset-colors-link" type="button" onClick={() => this.props.clearPaintFills()}>
              Clear All
            </div>
          </div>
          {
            this.props.paintFillLocations.map((loc, index) => (
              <PaintFillChooser key={loc.loc.id}
                loc={loc.loc}
                paints={loc.paints}
                selectedPaint={loc.selected}
                isError={this.props.showValidationWarnings && !loc.valid}
                onSelectPaintFill={(paint) => this.props.onSelectPaintFill(loc.loc.id, paint.id)}
              />
            ))
          }
          <div className="clearfix"></div>
        </div>
      }
    </div>
    {/*if there is only 1 option and it is 'Keep As Is' (numberOfLines: 0) then hide this section*/}
    {!(this.props.sightDots.options.length === 1 && this.props.sightDots.options[0].numberOfLines === 0 && this.props.topLines.options.length === 0) &&
      <div className="customize-form-section">
        {(this.props.sightDots.options.length > 0 || this.props.topLines.options > 0) &&
          <div className="customize-form-section-header">Select Topline*</div>
        }
        {(this.props.sightDots.options.length > 0 || this.props.topLines.options > 0) &&
          <div className="customize-form-section-content">
            <LineChooser name='sightDot'
              options={this.props.sightDots.options}
              selected={this.props.sightDots.selected}
              paints={this.props.sightDots.paints}
              isError={this.props.showValidationWarnings && (!this.props.sightDots.valid || !this.props.topLines.valid)}
              isPaintError={this.props.showValidationWarnings && !this.props.sightDots.paints.valid}
              onFieldChange={partial(this.props.onFieldChange, 'sightDot')}
              onSelectPaintFill={this.props.onSelectPaintFill}
            />
            <LineChooser name='topLine'
              radioGroup='sightDot'
              options={this.props.topLines.options}
              selected={this.props.topLines.selected}
              paints={this.props.topLines.paints}
              isError={this.props.showValidationWarnings && (!this.props.sightDots.valid || !this.props.topLines.valid)}
              isPaintError={this.props.showValidationWarnings && !this.props.topLines.paints.valid}
              onFieldChange={partial(this.props.onFieldChange, 'topLine')}
              onSelectPaintFill={this.props.onSelectPaintFill}
            />
          </div>
        }
      </div>
    }
    <div className="customize-form-section">
      {this.props.flangeLines.options.length > 0 && 
        <div className="customize-form-section-header">Select Flange*</div>
      }
      {this.props.flangeLines.options.length > 0 && 
        <div className="customize-form-section-content">
          <LineChooser name='flangeLine'
            options={this.props.flangeLines.options}
            selected={this.props.flangeLines.selected}
            paints={this.props.flangeLines.paints}
            isError={this.props.showValidationWarnings && !this.props.flangeLines.valid}
            isPaintError={this.props.showValidationWarnings && !this.props.flangeLines.paints.valid}
            onFieldChange={partial(this.props.onFieldChange, 'flangeLine')}
            onSelectPaintFill={this.props.onSelectPaintFill}
          />
        </div>
      }
      {(this.props.sightDots.options.length > 0 || this.props.topLines.options > 0 || this.props.flangeLines.options.length > 0 ) && !(this.props.buyAPutter && this.props.buyAPutter.selected) &&
        <div className="instructional-text">* $30.00 for the first and $20.00 for each additional line (or dot).</div>
      }
    </div>
    <div className="customize-form-section">
      <TrackedButtonLink trackingData="Next:Specs" className="next" to="specs">next: specs</TrackedButtonLink>
    </div>
    <NavWarning when={!this.props.validation.valid}
      message="Please complete all selections above before going to another page." />
    <PaintColorSwapModal 
      headerTitle="Change Color"
      headerText="If you select a new color here, we will apply that color to all the areas that have this color currently selected."
      colorSelectedText="Current Color"
      colorToSelectText="Select a new color:"
      currentPaintFill={this.state.currentPaintFill}
      allPaintColors={this.props.allPaintColors}
      replacePaint={this.props.replacePaint}
      cancel={() => this.setCurrentPaintFill(null)}
      className="paint-swapper"
      paintSwapValid={this.props.paintSwapValid}
    />
  </div>)
}

TopForm.defaultProps = {
  paintFillLocations: [],
  flangeLines: {},
  sightDots: {},
  topLines: {},
  showValidationWarnings:false,
  onFieldChange: identity,
  onSelectPaintFill: identity,
  onEnablePaintFill: identity,
};

const mapStateToProps = (state, ownProps) => {
  var p = { ...getTopVM(state.customize, false) }
  p.showValidationWarnings = state.app.blockedNavigation && !p.validation.valid
  return p;
}
const mapDispatchToProps = {
  onSelectPaintFill: actions.selectPaintFill,
  onFieldChange: actions.selectField,
  selectView: actions.selectView,
  onEnablePaintFill: actions.selectField,
  replacePaint: actions.replacePaint,
  resetPaintFills: actions.resetPaintFills,
  clearPaintFills: actions.clearPaintFills,
}

export default connect(mapStateToProps, mapDispatchToProps)(TopForm);
